import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { DSField, DSTextArea } from "@hundred5/design-system";
import { useField } from "formik";
import { ReactNode } from "react";

interface Props {
  id: string;
  name: string;
  label: ReactNode;
  required?: boolean;
  height?: string;
  maxLength?: number;
  variant?: "application-form" | "application-form-large";
  fontSize?: string;
}

export function FormikTextArea(props: Props) {
  const [field, meta] = useField(props.name);

  return (
    <StyledDSField
      fontSize={props.fontSize}
      for={props.id}
      label={props.label}
      required={props.required}
      error={meta.touched ? meta.error : undefined}
      variant={props.variant}
    >
      <DSTextArea
        {...field}
        id={props.id}
        height={props.height}
        maxLength={props.maxLength}
        error={meta.touched && meta.error != null}
      />
    </StyledDSField>
  );
}

const StyledDSField = styled(DSField)<{
  variant: "application-form" | "application-form-large" | undefined;
  fontSize?: string;
}>`
  ${(props) =>
    props.fontSize &&
    css`
      > label {
        font-size: ${props.fontSize};
      }
    `}

  ${(props) =>
    props.variant === "application-form" &&
    css`
      > label {
        text-transform: none;
      }
    `}

  ${(props) =>
    props.variant === "application-form-large" &&
    css`
      > label {
        text-transform: none;
        font-size: 14px;
      }
    `}
`;
